import { useMemo } from "react";
import { Channel, SimpleChannel } from "@hilos/types/private-schema";
import { useChannel } from "src/hooks/useChannel";
import { truncateWords } from "src/Helpers";
import { getAvailableChannelData } from "./Meta";

interface ChannelBadgeProps {
  channel: Channel | SimpleChannel;
}

interface ChannelBadgeByIdProps {
  id: string;
}

export default function ChannelBadge({ channel }: ChannelBadgeProps) {
  const channelData = useMemo(
    () => getAvailableChannelData(channel),
    [channel]
  );

  switch (channel.channel_type) {
    case "WHATSAPP":
      return (
        <span
          className={`inline-flex items-center rounded bg-${channel.channel_color}-200 px-1.5 text-xs font-medium text-${channel.channel_color}-700`}
        >
          {channelData && <channelData.icon className="mr-1 text-xs" />}
          {truncateWords(channel.name, 2)}
        </span>
      );
    default:
      return null;
  }
}

export function ChannelBadgeById({ id }: ChannelBadgeByIdProps) {
  const { channel } = useChannel(id);

  if (!channel) {
    return null;
  }

  return <ChannelBadge channel={channel} />;
}
